import { render, staticRenderFns } from "./myOrdersPage.vue?vue&type=template&id=569c9015&scoped=true"
import script from "./myOrdersPage.vue?vue&type=script&lang=ts"
export * from "./myOrdersPage.vue?vue&type=script&lang=ts"
import style0 from "./myOrdersPage.vue?vue&type=style&index=0&id=569c9015&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../soccer/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569c9015",
  null
  
)

export default component.exports